@if (mode === "create") {
  <p-button
    [label]="'accountMenu.usersManagement.addUser' | transloco"
    icon="pi pi-plus"
    severity="primary"
    (onClick)="showDialog()"
  />
} @else {
  <p-button
    icon="pi pi-pencil"
    [label]="'accountMenu.usersManagement.edit' | transloco"
    severity="primary"
    variant="outlined"
    (onClick)="showDialog()"
    size="small"
  />
}

<p-dialog
  [header]="mode === 'create' ? ('accountMenu.usersManagement.addUserTitle' | transloco) : ('accountMenu.usersManagement.editProfile' | transloco)"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '25rem' }"
>
  <form class="flex flex-col gap-4" [formGroup]="userForm">
    <div class="flex-1">
      <label for="firstName" class="text-sm text-primary-500">{{
        "accountMenu.usersManagement.firstName" | transloco
      }}</label>
      <input
        id="firstName"
        type="text"
        pInputText
        formControlName="firstName"
        [placeholder]="'accountMenu.usersManagement.firstNamePlaceholder' | transloco"
        [fluid]="true"
      />
    </div>

    <!-- Last Name -->
    <div class="flex-1">
      <label for="lastName" class="text-sm text-primary-500">{{
        "accountMenu.usersManagement.lastName" | transloco
      }}</label>
      <input
        id="lastName"
        type="text"
        pInputText
        formControlName="lastName"
        [placeholder]="'accountMenu.usersManagement.lastNamePlaceholder' | transloco"
        [fluid]="true"
      />
    </div>

    <!-- Email -->
    <div class="flex-1">
      <label for="emails" class="text-sm text-primary-500">{{
        "accountMenu.usersManagement.email" | transloco
      }}</label>
      <input
        id="emails"
        type="email"
        pInputText
        formControlName="email"
        [placeholder]="'accountMenu.usersManagement.emailPlaceholder' | transloco"
        [fluid]="true"
      />
    </div>

    <!-- Phone -->
    <div class="flex-1">
      <label for="phone" class="text-sm text-primary-500">{{
        "accountMenu.usersManagement.phone" | transloco
      }}</label>
      <input
        id="phone"
        type="text"
        pInputText
        formControlName="phone"
        [placeholder]="'accountMenu.usersManagement.phonePlaceholder' | transloco"
        [fluid]="true"
      />
    </div>

    <!-- Role -->
    <div class="mb-4">
      <label for="role" class="text-sm text-primary-500">{{
        "accountMenu.usersManagement.role" | transloco
      }}</label>
      <p-select
        id="role"
        [options]="roleOptions"
        formControlName="role"
        optionLabel="label"
        optionValue="value"
        optionDisabled="disabled"
        [placeholder]="'accountMenu.usersManagement.selectRole' | transloco"
        [showClear]="true"
        [styleClass]="'w-full'"
        appendTo="body"
      ></p-select>
    </div>

    @if (mode === 'edit') {
      <p-divider />
      <div class="mb-4">
        <h3 class="mb-2 text-sm font-semibold text-primary-500">
          {{ "admin.passwordReset.sectionTitle" | transloco }}
        </h3>
        <p class="mb-3 text-xs text-gray-600">
          {{ "admin.passwordReset.helpTextShort" | transloco }}
        </p>
        <p-button
          [label]="'admin.passwordReset.buttonLabel' | transloco"
          icon="pi pi-key"
          severity="secondary"
          variant="outlined"
          size="small"
          (onClick)="triggerPasswordReset()"
          [loading]="isResettingPassword"
          [styleClass]="'w-full'"
        />
      </div>

      <!-- Danger Zone -->
      <p-divider />
      <div class="mb-4 rounded-lg border border-red-200 bg-red-50 p-3">
        <h3 class="mb-2 text-sm font-semibold text-red-600">
          {{ "accountMenu.usersManagement.dangerZone" | transloco }}
        </h3>
        <p class="mb-3 text-xs text-red-600">
          {{ "accountMenu.usersManagement.deleteWarning" | transloco }}
        </p>
        <p-button
          [label]="'accountMenu.usersManagement.deleteUser' | transloco"
          icon="pi pi-trash"
          severity="danger"
          variant="outlined"
          size="small"
          (onClick)="deleteUser()"
          [styleClass]="'w-full'"
        />
      </div>
    }
  </form>
  <div class="flex justify-end gap-2">
    <p-button
      [label]="'accountMenu.usersManagement.cancel' | transloco"
      severity="secondary"
      (click)="visible = false"
    />
    <p-button
      [label]="'accountMenu.usersManagement.save' | transloco"
      (click)="submit()"
      [loading]="loading"
    />
  </div>
</p-dialog>
<p-confirmdialog rejectButtonStyleClass="p-button-outlined" />
